<template>
  <v-container
    fill-height
    justify-center
  >
    <v-card
      max-width="500"
    >
      <v-card-title class="justify-center primary--text text-h5">
        Gestion des cours Moodle
      </v-card-title>

      <v-card-text class="text-center">
        <span>Bienvenue ! Connectez-vous avec vos </span>

        <span class="font-weight-bold">identifiants Condorcet </span>

        <span>pour commencer à administrer vos cours.</span>

        <v-img
          :src="require('@/assets/undraw_Login_re_4vu2.svg')"
          :width="250"
          class="mt-6 mx-auto"
        ></v-img>
      </v-card-text>

      <v-card-actions>
        <v-btn
          block
          large
          color="primary"
          @click="login"
        >
          Connexion
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { login } from '@/auth';

export default {
  name: 'Login',

  methods: {
    login,
  },
};
</script>
